module.exports = __webpack_public_path__ + "media/images/sp/brands/suns/logo-bc4304efe538764274fbdad4c2ca448b.png";